import React, { useState, useEffect } from "react";
import { Toggle, NumberInput } from "../shared";

export default function PaymentProtocols({ protocols, onSave, disabled }) {
  const [values, setValues] = useState({});
  const [dirty, setDirty] = useState(false);

  useEffect(() => {
    if (protocols) {
      setValues(protocols);
      setDirty(false);
    }
  }, [protocols]);

  const handleToggle = (proto, val) => {
    const next = {
      ...values,
      [proto]: { ...values[proto], enabled: val },
    };
    setValues(next);
    setDirty(true);
  };

  const handleField = (proto, field, val) => {
    const next = {
      ...values,
      [proto]: { ...values[proto], [field]: val },
    };
    setValues(next);
    setDirty(true);
  };

  const handleSave = () => {
    onSave(values);
    setDirty(false);
  };

  return (
    <div className={`mcp-payment-protocols ${disabled ? "mcp-disabled-section" : ""}`}>
      <h5 className="mcp-subsection-title">Payment protocols</h5>

      {/* x402 */}
      <div className="mcp-protocol-item">
        <Toggle
          label="x402"
          checked={values.x402?.enabled ?? false}
          onChange={(val) => handleToggle("x402", val)}
          disabled={disabled}
        />
        {values.x402?.enabled && (
          <div className="mcp-protocol-config">
            <NumberInput
              label="Auto-approve threshold"
              value={values.x402?.autoApproveThreshold ?? 5}
              onChange={(val) => handleField("x402", "autoApproveThreshold", val)}
              disabled={disabled}
            />
          </div>
        )}
      </div>

      {/* MPP */}
      <div className="mcp-protocol-item">
        <Toggle
          label="MPP (Machine Payment Protocol)"
          checked={values.mpp?.enabled ?? false}
          onChange={(val) => handleToggle("mpp", val)}
          disabled={disabled}
        />
        {values.mpp?.enabled && (
          <div className="mcp-protocol-config">
            <NumberInput
              label="Auto-approve threshold"
              value={values.mpp?.autoApproveThreshold ?? 5}
              onChange={(val) => handleField("mpp", "autoApproveThreshold", val)}
              disabled={disabled}
            />
            <div className="mcp-field">
              <label className="mcp-field-label">Payment method</label>
              <select
                className="mcp-select"
                value={values.mpp?.method ?? "tempo"}
                onChange={(e) => handleField("mpp", "method", e.target.value)}
                disabled={disabled}
              >
                <option value="tempo">Tempo</option>
                <option value="stripe">Stripe</option>
              </select>
            </div>
          </div>
        )}
      </div>

      {dirty && (
        <button
          type="button"
          className="fugu--btn mcp-btn-save"
          onClick={handleSave}
        >
          <span>Save</span>
        </button>
      )}
    </div>
  );
}
